import { useEffect } from 'react';
import { navigate } from 'gatsby';
import * as React from 'react';
export default {
  useEffect,
  navigate,
  React
};